import React from 'react';
import { Section } from './ui/Section';
import { CheckIcon } from 'lucide-react';
export function SolutionReveal() {
  return <Section className="bg-stone-900 text-stone-50" data-id="element-154">
      <div className="text-center mb-16" data-id="element-155">
        <span className="text-amber-400 font-bold tracking-wider text-sm uppercase mb-4 block" data-id="element-156">
          La Solución
        </span>
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-157">
          Sistema 3C + Plantillas Copiar/Pegar
        </h2>
        <p className="text-xl text-stone-300 max-w-2xl mx-auto" data-id="element-158">
          Esta guía te enseña una sola cosa (pero bien): <br data-id="element-159" />
          <span className="text-white font-semibold" data-id="element-160">
            Cómo hablarle a ChatGPT para que trabaje como tu asistente.
          </span>
        </p>
      </div>

      <div className="bg-stone-800 rounded-3xl p-8 md:p-12 border border-stone-700 max-w-3xl mx-auto relative overflow-hidden" data-id="element-161">
        <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl -mr-32 -mt-32" data-id="element-162"></div>

        <h3 className="text-2xl font-bold text-white mb-8 text-center" data-id="element-163">
          El Método 3C
        </h3>

        <div className="space-y-6" data-id="element-164">
          {[{
          c: 'Contexto',
          desc: 'Tu realidad (qué vendes, a quién, objetivo, restricciones)'
        }, {
          c: 'Comando',
          desc: 'La tarea exacta (escribe, resume, crea, convierte, organiza)'
        }, {
          c: 'Criterio',
          desc: 'Cómo debe quedar (tono, longitud, formato, objetivo)'
        }].map((item, i) => <div key={i} className="flex items-start bg-stone-900/50 p-6 rounded-xl border border-stone-700" data-id="element-165">
              <div className="flex-shrink-0 h-10 w-10 rounded-full bg-amber-600 flex items-center justify-center text-white font-bold text-lg mr-4" data-id="element-166">
                {item.c[0]}
              </div>
              <div data-id="element-167">
                <h4 className="text-xl font-bold text-white mb-1" data-id="element-168">{item.c}</h4>
                <p className="text-stone-300" data-id="element-169">{item.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="mt-10 text-center p-6 bg-amber-900/20 rounded-xl border border-amber-900/30" data-id="element-170">
          <p className="text-lg text-amber-100" data-id="element-171">
            Cuando usas 3C, dejas de "adivinar" qué escribir. <br data-id="element-172" />
            <span className="font-bold text-white" data-id="element-173">
              Y ChatGPT deja de "adivinar" quién eres tú.
            </span>
          </p>
        </div>
      </div>
    </Section>;
}